module.exports = __webpack_public_path__ + "img/img-3.dcc6494b.png";